<template>
  <div
    id="arrange"
    ref="anchorBox"
    v-if="arrangeList && arrangeList.length !== 0"
  >
    <div class="inner-box" v-if="arrangeList_computed.length !== 0">
      <div class="day-title-bg"></div>
      <div
        class="day-box"
        v-for="(arrange, key) in arrangeList_computed"
        :key="key"
      >
        <div class="day-title">
          <i class="icon_1"></i>
          <div class="day">
            <div class="label-box">
              <span class="label-shadow">{{ arrange.day }}</span>
              <span class="label-text">{{ arrange.day }}</span>
            </div>
          </div>
          <div class="week">
            <div class="label-box">
              <span class="label-shadow">{{ arrange.week }}</span>
              <span class="label-text">{{ arrange.week }}</span>
            </div>
          </div>
          <div class="title">
            <div class="label-box">
              <span class="label-shadow">{{ arrange.title }}</span>
              <span class="label-text">{{ arrange.title }}</span>
            </div>
          </div>
          <i class="icon_2"></i>
        </div>
        <div
          class="category-box"
          v-if="arrange.categoryList && arrange.categoryList.length !== 0"
        >
          <div class="category-list">
            <div
              class="category"
              v-for="(category, key) in arrange.categoryList"
              :key="key"
              :class="{ anchor: category.status === 3 }"
              @click="showTeams(category)"
            >
              <div class="left-box" :class="{ active: category.status === 2 }">
                <div class="time">{{ category.time }}</div>
                <div class="status">{{ getStatus(category.status) }}</div>
              </div>
              <div class="right-box">
                <div class="inner">
                  <div class="top-box">
                    <div class="title">
                      <div class="bg"></div>
                      <div class="label-box">
                        <span class="label-shadow">{{ category.title }}</span>
                        <span class="label-text">{{ category.title }}</span>
                      </div>
                    </div>
                    <UiButton
                      class="details"
                      colorType="red-complex"
                      :class="{ hasPoints: category.status !== 1 }"
                      @click="(e) => showScores(e, category, `${arrange.day} ${arrange.week} ${category.title}`)"
                    >
                      <div class="label-box">
                        <span class="label-shadow">积分详情</span>
                        <span class="label-text">积分详情</span>
                      </div>
                      <i></i>
                    </UiButton>
                  </div>
                  <ul
                    class="bottom-box"
                    v-if="category.teams && category.teams.length !== 0"
                  >
                    <li
                      v-for="i in 3"
                      :key="i"
                      :style="{
                        'background-image': `url(${
                          category.teams[i - 1]
                            ? category.teams[i - 1]?.avatar || defaultAvatar
                            : defaultAvatar
                        })`,
                      }"
                    ></li>
                    <li name="4" class="more">
                      <div>更多队伍</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UiEmpty v-else tip="暂无赛程" hook="vh" />
  </div>
</template>

<script setup>
import { computed, nextTick, ref, watch } from 'vue'
import UiButton from '@/components/ui-button';
import UiEmpty from '@/components/ui-empty';

const props = defineProps({
  openScore: {
    type: Function,
    default: () => {},
  },
  openTeams: {
    type: Function,
    default: () => {},
  },
  arrangeList: {
    type: Array,
    default: () => [],
  },
  handleAnchor: {
    type: Function,
    default: () => {},
  },
});

// arrangeList: [],
const phaseID = ref("");

const defaultAvatar = ref("https://website.xdcdn.net/poster/sausage/match/zhanduilogo/z51MQgVN.png");

// 模板 ref
const anchorBox = ref(null);

const arrangeList_computed = computed(() => {
  let list = [];
  if (props.arrangeList && props.arrangeList.length !== 0) {
    if (phaseID.value !== "" && phaseID.value !== "all") {
      list = props.arrangeList.filter(
        (item) => item.categoryId === phaseID.value
      );
    } else {
      list = props.arrangeList;
    }
  }

  return list;
});

watch(() => props.arrangeList, () => {
  nextTick(() => {
    let $anchorBox = anchorBox.value,
      $anchors = document.getElementsByClassName("anchor");
    if ($anchors && $anchors.length !== 0) {
      let $end = $anchors[$anchors.length - 1];
      let offsetLeft = $end.offsetLeft - $anchorBox.offsetLeft;
      props.handleAnchor(offsetLeft);
    }
  });
});

function getStatus(value) {
  let subStatus = "";
  switch (Number(value)) {
    case 1:
      subStatus = "未开始";
      break;
    case 2:
      subStatus = "进行中";
      break;
    case 3:
      subStatus = "已结束";
      break;
  }

  return subStatus;
}
function showTeams(category) {
  // 参赛战队
  props.openTeams(category.teams ? category.teams : []);

  // 埋点
  if(typeof tapdb === 'undefined') return;
  tapdb.trackEvent('查看队伍', {
    '#schedule_id': category.title
  });
}
function showScores(e, category, title) {
  e.stopPropagation();

  // 积分详情
  props.openScore(category.scheduleCode, title);

  // 埋点
  if(typeof tapdb === 'undefined') return;
  tapdb.trackEvent('查看对局', {
    '#schedule_id': category.title,
    "#match_id": '总积分'
  });
}
function switchPhase(phaseID_) {
  phaseID.value = phaseID_;
}

// 父组件(schedule/index.vue)通过 $refs.arrange.switchPhase 调用
defineExpose({ switchPhase });
</script>

<style lang="scss" scoped>
#arrange {
  position: relative;
  height: 100%;
  width: fit-content;
  margin: 0 auto;

  .inner-box {
    display: flex;
    height: 100%;
  }

  .day-title-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: get_vh(64);
    border-radius: get_vh(10);
    background: linear-gradient(180deg, #FFD0D1 13%, #FFF 100%);
  }

  .day-box {
    width: get_vh(410);
    margin-right: get_vh(17);
    display: flex;
    flex-direction: column;

    &:last-of-type {
      margin-right: 0;
    }

    .day-title {
      position: relative;
      width: 100%;
      height: get_vh(64);
      display: flex;
      align-items: center;
      overflow: hidden;

      i.icon_1 {
        width: get_vh(36);
        height: get_vh(36);
        @include icon_status('match_date');
        margin-left: get_vh(6);
      }
      i.icon_2 {
        position: absolute;
        top: 50%;
        margin-top: get_vh(-10);
        left: get_vh(340);
        width: get_vh(37);
        height: get_vh(19);
        background: url(https://website.xdcdn.net/poster/58881/26match/icon/PLwat5ic.png) center/contain no-repeat;
        margin-left: get_vh(10);
      }

      .day,
      .week,
      .title {
        position: relative;
        font-size: get_vh(24);
        color: $black-33;
        margin-left: get_vh(10);
        .label-box {
          .label-shadow {
            color: #FFFFFF;
          }
          .label-text {
            color: #6D0402;
          }
        }
      }
    }

    .category-box {
      flex: 1;
      width: 100%;
      margin-top: get_vh(28);
      overflow-x: hidden;
      overflow-y: scroll;

      .category-list {
        width: 100%;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;

        .category {
          box-sizing: border-box;
          width: 100%;
          height: get_vh(140);
          border: get_vh(2) solid #FFFFFF;
          background: url(https://website.xdcdn.net/poster/58881/26match/common/PLxBMug7.jpg) center/100% 100% no-repeat;
          padding: get_vh(8) get_vh(16) get_vh(8) get_vh(8);
          margin-bottom: get_vh(16);
          @include boxShadowSet_Btn;
          display: flex;
          -webkit-tap-highlight-color: transparent;

          .left-box {
            box-sizing: border-box;
            width: get_vh(97);
            height: 100%;
            border-radius: get_vh(5);
            color: #B67E7F;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: get_vh(2) solid #FFFFFF;
            background: linear-gradient(180deg, #F4CACB, #FBEBEC);
            @include boxShadowSet_Btn;

            &.active {
              background: linear-gradient(180deg, #F6D029, #FFF6B2);
              color: #CA7C0E;
            }

            .time {
              font-size: get_vh(40);
              font-weight: bold;
              font-family: NumFont;
              line-height: 1.2;
            }
            .status {
              font-size: get_vh(20);
              font-weight: 500;
              line-height: 1.2;
            }
          }

          .right-box {
            flex: 1;

            .inner {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;

              .top-box {
                position: relative;
                height: get_vh(44);
                display: flex;
                justify-content: space-between;

                .title {
                  position: relative;
                  display: flex;
                  align-items: center;
                  font-size: get_vh(20);

                  .bg {
                    position: absolute;
                    bottom: get_vh(8);
                    left: get_vh(5);
                    width: calc(100% - #{get_vh(8)});
                    height: get_vh(8);
                    background: #F51A23;
                  }
                  .label-box {
                    padding: 0 get_vh(7);
                    span {
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    }
                    .label-shadow {
                      color: rgba(#FFFFFF, 80%);
                    }
                    .label-text {
                      color: #6D0402;
                    }
                  }
                }

                .details {
                  position: absolute;
                  right: 0;
                  top: 0;
                  align-items: center;
                  width: get_vh(126);
                  height: get_vh(44);
                  font-size: get_vh(20);
                  font-weight: 500;
                  display: none;
                  i {
                    display: inline-block;
                    width: get_vh(13);
                    height: get_vh(14);
                    background: url(https://website.xdcdn.net/poster/58881/26match/icon/PLy7xpl4.png) center/contain no-repeat;
                    margin-left: get_vh(5);
                  }
                  &.hasPoints {
                    display: flex;
                  }
                }
              }

              .bottom-box {
                height: get_vh(60);
                margin-left: get_vh(7);
                display: flex;
                justify-content: space-between;
                li {
                  width: get_vh(60);
                  height: get_vh(60);
                  box-sizing: border-box;
                  border: get_vh(2) solid #F9CDCE;
                  border-radius: 50%;
                  background-position: center;
                  background-repeat: no-repeat;
                  background-size: cover;

                  &.more {
                    background-color: #fff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    div {
                      width: 50%;
                      text-align: center;
                      color: #C96B6D;
                      font-weight: bold;
                      white-space: pre-line;
                      @include r(font-size, 14);
                      @include r(line-height, 16);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
